<template>
  <div class="AppMainSidebar">
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
    <el-tree
      class="filter-tree"
      :data="list"
      :props="defaultProps"
      :filter-node-method="filterNode"
      ref="tree"
      :node-key="nodeKey"
      highlight-current
      check-on-click-node
      @node-click="nodeClick"
      :default-expanded-keys="expandedList"
      @node-collapse="nodeCollapse"
      @node-expand="nodeExpand"
      @current-change="currentChange"
      accordion
    >
    </el-tree>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AppMainSidebar',
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    nodeKey: {
      type: String,
      default: () => {
        return 'houseId';
      },
    },
  },
  computed: {
    ...mapGetters([]),
  },
  data() {
    return {
      defaultProps: {
        children: 'childTree',
        label: 'areaName',
      },
      filterText: '',
      expandedList: [], // 作为el-tree 的默认展开选项，在 数据刷新之后el-tree 会自动根据这个数据来展开对应选项
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.areaName.indexOf(value) !== -1;
    },

    // 节点展开
    nodeExpand(data) {
      // console.log('展开数据：', data);
      this.expandedList.push(data.areaCode); // 在节点展开是添加到默认展开数组
    },

    // 节点闭合
    nodeCollapse(data) {
      this.expandedList.splice(this.expandedList.indexOf(data.areaCode), 1); // 收起时删除数组里对应选项
    },

    currentChange() {},

    nodeClick(data, node) {
      this.data = data;
      this.$store.dispatch('area/setCheckNodeData', node);
      // 切换节点时，清空其他城市所勾选的城市
      this.$store.dispatch('area/setCheckAreaListID', []);
      let obj = {
        pageSize: 20,
        pageIndex: 1,
      };
      this.$store.dispatch('area/setPaginObj', obj);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-input__inner {
  margin-bottom: 20px;
}

// tree 每一项的高度
/deep/ .el-tree-node__content {
  height: 40px;
}
.AppMainSidebar {
  width: 280px;
  height: 100px;
  margin-top: 20px;
}

/deep/ .is-current {
  color: #409eff;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
